import { MsalProvider } from '@azure/msal-react';
import { ConfigContext, LoggerContext } from '@gplibraries/react/context';
import { AppContextProvider, Theme } from '@gplibraries/react/components';
import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';

/**
 * Wrapper that encapsulates all the necessary context providers for the application.
 *
 * @param msalInstance
 * @param appConfig
 * @param queryClient
 * @param children
 * @return {JSX.Element}
 */
export default function Providers({ authClient, appConfig, queryClient, logger, children }) {
  return (
    <LoggerContext.Provider value={logger}>
      <MsalProvider instance={authClient}>
        <ConfigContext.Provider value={appConfig}>
          <Theme defaultTheme={appConfig.theme}>
            <AppContextProvider>
              <QueryClientProvider client={queryClient}>
                {children}
                <ReactQueryDevtools />
              </QueryClientProvider>
            </AppContextProvider>
          </Theme>
        </ConfigContext.Provider>
      </MsalProvider>
    </LoggerContext.Provider>
  );
}
